/**
 * ClariMe Brand Constants
 *
 * Central place for brand colors and design tokens.
 * Uses Tailwind utility class names.
 */

export const brand = {
  primary: 'from-teal-500 to-cyan-500',
  primarySolid: 'bg-teal-500',
  primaryHover: 'hover:bg-teal-600',
  primaryText: 'text-teal-600',
  primaryLight: 'bg-teal-50',
  primaryBorder: 'border-teal-200',
  accent: 'from-violet-500 to-purple-600',
};

export const specialtyColors = {
  'Oncology': 'from-purple-500 to-violet-600',
  'Primary Care': 'from-blue-500 to-indigo-600',
  'Cardiology': 'from-red-500 to-rose-600',
  'Neurology': 'from-amber-500 to-orange-600',
  'Orthopedics': 'from-emerald-500 to-teal-600',
  'General': 'from-slate-500 to-slate-600',
};

export const specialtySolidColors = {
  'Oncology': 'bg-purple-500',
  'Primary Care': 'bg-blue-500',
  'Cardiology': 'bg-red-500',
  'Neurology': 'bg-amber-500',
  'Orthopedics': 'bg-emerald-500',
  'General': 'bg-slate-500',
};
